function cookiesBanner() {
  console.log('Cookies Banner Success Loaded');

  // Cookies Settings
  function setCookie(cName, cValue, expDays) {
    let date = new Date()
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()
    document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/'
  }

  function getCookie(cName) {
    const name = cName + '='
    const cCoded = decodeURIComponent(document.cookie)
    const cArr = cCoded.split('; ')
    let value
    cArr.forEach(val => {
      if (val.indexOf(name) === 0) value = val.substring(name.length)
    })

    return value
  }

  // Variables
  const consents = {}
  const consentsCheckbox = document.querySelectorAll('#consents input');
  let changeSettingsCookies = document.querySelectorAll('.cookies-b-activator');
  let recaptchaWarning = document.querySelectorAll('.cookies-warning-recaptcha');
  let submitButtons = document.querySelectorAll('.contact_form_submit');

  // Elements Functions Controls
  const hideCookieWarning = (value) => {
    if (value.length > 0) {
      value.forEach(element => {
        element.classList.add('hidden');
      })
    }
  }

  const showCookieWarning = (value) => {
    if (value.length > 0) {
      value.forEach(element => {
        element.classList.remove('hidden');
      })
    }
  }

  const showElementFunction = (value) => {
    if (value.length > 0) {
      value.forEach(element => {
        element.style.display = 'block';
      })
    }
  }

  const hideElementFunction = (value) => {
    if (value.length > 0) {
      value.forEach(element => {
        element.style.display = 'none';
      })
    }
  }

  // Type Functions Checked
  const googleScripts = () => {
    let headGoogleScript = document.head.querySelectorAll('script[type="cookie-consent/google"]');
    let headGoogleLink = document.head.querySelectorAll('script[type="cookie-consent/google-link"]');

    if (headGoogleScript.length > 0) {
      headGoogleScript.forEach(script => {
        let headGoogleScriptInner = script.innerHTML;
        let newHeadGoogleScript = document.createElement('script');

        newHeadGoogleScript.innerHTML = headGoogleScriptInner;
        document.head.appendChild(newHeadGoogleScript);
        script.remove();
      })
    }

    if (headGoogleLink.length > 0) {
      headGoogleLink.forEach(script => {
        let headGoogleLinkInner = script.src;
        let newHeadGoogleLink = document.createElement('script');

        newHeadGoogleLink.src = `${headGoogleLinkInner}`;
        document.head.appendChild(newHeadGoogleLink);
        script.remove();
      })
    }
  }

  const recaptchaScripts = () => {
    let recaptchaLink = document.querySelectorAll('script[type="cookie-consent/recaptcha-link"]');
    let recaptchaScript = document.querySelectorAll('script[type="cookie-consent/recaptcha"]');

    if (recaptchaLink.length > 0) {
      recaptchaLink.forEach(script => {
        let recaptchaLinkSrc = script.src;
        let newRecaptchaLink = document.createElement('script');

        newRecaptchaLink.setAttribute('src', `${recaptchaLinkSrc}`);
        newRecaptchaLink.setAttribute('async', '')
        newRecaptchaLink.setAttribute('defer', '')
        document.body.appendChild(newRecaptchaLink);
        script.remove();
      })
    }

    if (recaptchaScript.length > 0) {
      setTimeout(() => {
        recaptchaScript.forEach(script => {
          let recaptchaScriptHtml = script.innerHTML;
          let newRecaptchaScriptHtml = document.createElement('script');

          newRecaptchaScriptHtml.innerHTML = `${recaptchaScriptHtml}`;
          document.body.appendChild(newRecaptchaScriptHtml);
          script.remove();
        })
      }, 100);
    }
  }

  const recaptchaCF7Scripts = () => {
    setTimeout(function () {
      console.log('RECAPTCHA');

      var t;
      wpcf7_recaptcha = { ...(null !== (t = wpcf7_recaptcha) && void 0 !== t ? t : {}) };
      const c = wpcf7_recaptcha.sitekey,
        { homepage: n, contactform: a } = wpcf7_recaptcha.actions,
        o = (e) => {
          const { action: t, func: n, params: a } = e;
          grecaptcha
            .execute(c, { action: t })
            .then((e) => {
              const c = new CustomEvent("wpcf7grecaptchaexecuted", { detail: { action: t, token: e } });
              document.dispatchEvent(c);
            })
            .then(() => {
              "function" == typeof n && n(...a);
            })
            .catch((e) => console.error(e));
        };
      if (
        (grecaptcha.ready(() => {
          o({ action: n });
        }),
          document.addEventListener("change", (e) => {
            o({ action: a });
          }),
          "undefined" != typeof wpcf7 && "function" == typeof wpcf7.submit)
      ) {
        const e = wpcf7.submit;
        wpcf7.submit = (t, c = {}) => {
          o({ action: a, func: e, params: [t, c] });
        };
      }
      document.addEventListener("wpcf7grecaptchaexecuted", (e) => {
        const t = document.querySelectorAll('form.wpcf7-form input[name="_wpcf7_recaptcha_response"]');
        for (let c = 0; c < t.length; c++) t[c].setAttribute("value", e.detail.token);
      });

      console.log('RECAPTCTCHA END');
    }, 500);
  }

  // Accepts and Pushing Functions
  const pushScript = () => {
    const consents = JSON.parse(getCookie('cookie-aflaseal'))
    Object.keys(consents).map(consent => {
      switch (consent) {
        case 'google':
          googleScripts()
          break
        case 'recaptcha':
          recaptchaScripts()
          break
        default:
          break
      }
    })

    for (var key in consents) {
      if (consents.hasOwnProperty(key)) {
        if (consents[key] === true) {
          document.querySelector(`input[data-conset="${key}"]`).checked = true
        }
      }
    }

    if (consents.recaptcha === true) {
      hideCookieWarning(recaptchaWarning)
      recaptchaCF7Scripts()
      if (submitButtons.length > 0) {
        submitButtons.forEach(element => {
          element.style.display = 'flex'
        })
      }
    } else {
      showCookieWarning(recaptchaWarning)
      if (submitButtons.length > 0) {
        submitButtons.forEach(element => {
          element.style.display = 'none'
        })
      }
    }
  }

  const checkSettings = () => {
    document.querySelector('.cookies').classList.add('is-hidden');
    document.querySelector('.cookies-settings').classList.add('is-hidden');
    document.body.style.overflow = 'auto'

    const consents = {}

    consentsCheckbox.forEach(checkbox => {
      if (checkbox.checked) {
        const consetName = checkbox.getAttribute('data-conset');

        consents[consetName] = true
      }
    })

    setCookie('cookie-aflaseal', JSON.stringify(consents), 30);
    pushScript()
  }

  const checkAll = () => {
    document.querySelector('.cookies').classList.add('is-hidden');
    document.querySelector('.cookies-settings').classList.add('is-hidden');
    document.body.style.overflow = 'auto'

    const consents = {}

    consentsCheckbox.forEach(checkbox => {
      checkbox.setAttribute('checked', 'true');
      const consetName = checkbox.getAttribute('data-conset');

      consents[consetName] = true
    })
    setCookie('cookie-aflaseal', JSON.stringify(consents), 30);
    pushScript()
  }

  document.querySelector('#closed').addEventListener('click', (e) => {
    e.preventDefault;
    document.querySelector('.cookies-settings').classList.add('is-hidden');
    document.querySelector('.cookies').classList.add('is-hidden');
    document.body.style.overflow = 'auto';
  })

  document.querySelector('#show-extended').addEventListener('click', (e) => {
    e.preventDefault;
    document.querySelector('.cookies').classList.add('is-hidden');
    document.querySelector('.cookies-settings').classList.remove('is-hidden');
  })

  document.querySelectorAll('#cookies-btn-save-all').forEach(button => {
    button.addEventListener('click', () => {
      checkAll()
    })
  })

  document.querySelectorAll('#cookies-btn-accept-my-setting').forEach(button => {
    button.addEventListener('click', () => {
      checkSettings()
    })
  })

  document.querySelectorAll('#cookies-btn-save-nessesery').forEach(button => {
    button.addEventListener('click', () => {
      checkSettings()
    })
  })

  function cookieMess() {
    if (!getCookie('cookie-aflaseal')) {
      document.querySelector('.cookies').classList.remove('is-hidden');
      document.body.style.overflow = 'hidden';
      showCookieWarning(recaptchaWarning)
      if (submitButtons.length > 0) {
        submitButtons.forEach(element => {
          element.style.display = 'none'
        })
      }
    } else {
      pushScript()
    }
  }

  window.addEventListener('load', cookieMess)

  if (changeSettingsCookies.length > 0) {
    changeSettingsCookies.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.cookies').classList.remove('is-hidden');
        document.body.style.overflow = 'hidden'
      })
    })
  }
}
cookiesBanner()